





























































































































import TabsInfoMixin from '../../../devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import { Reports, Global } from '@/store';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import CabinetAlertsTable from './CabinetAlertsTable.vue';
import CabinetEventsTable from './CabinetEventsTable.vue';
import IncidentDetailsDialog from './IncidentDetailsDialog.vue';
import { alerts_with_header_1, alerts_with_header_2, alerts_with_header_3, single_unit_alert_types, single_unit_probability_alert_types } from '@/store/modules/Global';
import { event_consumption_during_day_types, event_abnormal_types, event_consumption_anomalies_types } from '@/store/modules/Global';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import IncidentsTableView from './IncidentsTableView.vue';
import { getIncidentTypeName } from '@/modules/IncidentTypeUtils';

@Component({
  components: {
    CabinetAlertsTable,
    CabinetEventsTable,
    IncidentsTableView,
    IncidentDetailsDialog
  }
})
class IncidentsTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Global.State('lang') lang;
  @Reports.Getter('cabinets_fixtures') cabinets_fixtures;

  // @ts-ignore
    @Prop() device;
    @Prop() incidents_data;
    @Prop() alerts_list;
    @Prop() events_list;

    loading = true;
    alert_types = {};
    event_types = {};
    prop_utils = PropUtils;
    incident_details_dialog_open = false;
    selected_incident = null;
    alerts_with_header_1 = alerts_with_header_1;
    alerts_with_header_2 = alerts_with_header_2;
    alerts_with_header_3 = alerts_with_header_3;
    single_unit_alert_types = single_unit_alert_types;
    single_unit_probability_alert_types = single_unit_probability_alert_types;
    event_consumption_during_day_types = event_consumption_during_day_types;
    event_abnormal_types = event_abnormal_types;
    event_consumption_anomalies_types = event_consumption_anomalies_types;
    table_view = false;
    type = '';

    getIncidentTypeName(incidentType: string, isEvent: boolean): string {
      return getIncidentTypeName(incidentType, isEvent, this.lang);
    }

    mounted() {
      this.setCabinetIncidentsData();
    }

    handleIncidentClicked(incident, type){
      this.type = type;
      this.selected_incident = incident;
      this.setIncidentDialogIsOpen(true);
    }

    setIncidentDialogIsOpen(is_open){
      this.incident_details_dialog_open = is_open;
      if (!is_open) {
        this.selected_incident = null;
      }
    }

    get alertHeaders() {
      return [[], ['phase'], ['circuit_number'], ['circuit_number', 'pole', 'phase', 'probability'], ['circuit_number', 'pole', 'phase']];
    }

    get eventHeaders(){
      return [['phase', 'unusual_measure'], ['actual_consumption'], ['window_type', 'description'], ['expected_consumption', 'actual_consumption', 'percentage_deviation']];
    }

    get timezone(){
      return this.$store.state.Global.timezone || this.$store.state.Global.allProjectsTimezone || 'Asia/Tel_Aviv';
    }

    getCabinetWindow(valueStr) {
      try {
        // Check if it's a 24/7 window
        if (valueStr.includes('24/7')) {
          return '24/7';
        }

        // Remove the 'new window - ' prefix if it exists
        let jsonStr = valueStr;
        if (jsonStr.includes('new window - ')) {
          jsonStr = jsonStr.replace('new window - ', '');
        }

        // Parse the JSON string to get start and end times
        const windowObj = JSON.parse(jsonStr.replace(/'/g, '"'));
        if (!windowObj.start || !windowObj.end) {
          return valueStr; // Return original if parsing fails
        }

        // Get timezone offset in hours
        const timezoneStr = this.timezone;
        const now = new Date();
        const tzOffset = moment.tz(timezoneStr).utcOffset() / 60; // Convert minutes to hours

        // Parse and adjust the times based on timezone
        const startParts = windowObj.start.split(':');
        const endParts = windowObj.end.split(':');
        
        let startHour = parseInt(startParts[0], 10) + tzOffset;
        const startMinute = parseInt(startParts[1], 10);
        let endHour = parseInt(endParts[0], 10) + tzOffset;
        const endMinute = parseInt(endParts[1], 10);
        
        // Handle overflow for hours
        startHour = (startHour + 24) % 24;
        endHour = (endHour + 24) % 24;
        
        // Format the times with leading zeros
        const formattedStart = `${String(Math.floor(startHour)).padStart(2, '0')}:${String(startMinute).padStart(2, '0')}`;
        const formattedEnd = `${String(Math.floor(endHour)).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}`;
        
        // Return the formatted string with translations
        return `${this.$t('from')} ${formattedStart} ${this.$t('to')} ${formattedEnd}`;
      } catch (e) {
        console.error('Error parsing cabinet window value:', e, valueStr);
        return valueStr; // Return original value if there's an error
      }
    }

    setCabinetIncidentsData() {
      this.loading = true;
      this.setCabinetAlertTypes();
      this.setCabinetEventTypes();
      this.loading = false;
    }

    clearSelections(){
      this.$refs.table['clearSelections']();
    }

    @Watch('alerts_list')
    setCabinetAlertTypes(){
      const alert_types = {};
      const project_alerts = cloneDeep(this.alerts_list);
      const single_unit_alerts = this.single_unit_alert_types.concat(this.single_unit_probability_alert_types);
      project_alerts.forEach((alert) => {
        alert.time = moment(alert.created).valueOf();
        alert.parsed_time = Utils.convertTimestamp(alert.time, 'DD/MM/YYYY HH:mm:ss', this.timezone);
        alert.parsed_type = this.getIncidentTypeName(alert.incident_type, false);
        alert.parsed_priority = this.$t(Utils.getAlertPriority(alert.priority));
        alert.relative_time = Utils.translateRelativeTime(Utils.getRelativeTime(alert.time));

        const alert_type = alert.incident_type;
        if (single_unit_alerts.includes(alert_type)){
          if (alert.incident_type === 'daytime_light_fault') {
            alert.probability = alert.probability * 100;
            if (alert.probability >= 75){
              alert.bold = true;
            }
          }
          const device = this.$store.state.Reports.reportsList.find((device) => device.id === alert.device_id);
          if (device) {
            alert.circuit_number = device['meta.device'].circuit_number;
            alert.phase = device['meta.device'].phase;
            alert.pole = device['meta.device'].pole_number;
          }else return;
        }else if (alerts_with_header_2.includes(alert_type)) {
          alert.phase = Utils.convertNumberToRealPhase(alert.phase);
        }else if (alerts_with_header_3.includes(alert_type)) {
          alert.circuit_number = alert.circuit_number;
        }
        if (alert_types[alert_type]) {
          alert_types[alert_type].list.push(alert);
        }else {
          alert_types[alert_type] = { 
            priority_id: alert.priority,
            list: [alert],
            priority_color: alert.priority === 1 ? 'green' : alert.priority === 2 ? 'yellow' : 'red'
          };
        }
      });

      this.alert_types = alert_types;
    }
    
    @Watch('events_list')
    setCabinetEventTypes(){
      const event_types = {};
      const project_events = cloneDeep(this.events_list);
      project_events.forEach((event) => {
        event.time = moment(event.created).valueOf();
        event.parsed_time = Utils.convertTimestamp(event.time, 'DD/MM/YYYY HH:mm:ss', this.timezone);
        event.parsed_type = this.getIncidentTypeName(event.event_type, true);
        event.parsed_priority = this.$t('Info');
        event.relative_time = Utils.translateRelativeTime(Utils.getRelativeTime(event.time));
        if (event.event_type === 'cabinet_alerts_window_change') {
          event.window_type = (event.value).includes('24/7') ? '24/7' : this.$t('Custom Time Window');
          event.description = (event.value).includes('24/7') ? 
            this.$t('System detected cabinet operating') + ' 24/7' : 
            this.$t('System detected cabinet operating') + ' ' + this.getCabinetWindow(event.value);
        }else if (event_abnormal_types.includes(event.event_type)) {
          event.phase = Utils.convertNumberToRealPhase(event.phase);
          event.unusual_measure = event.value ? event.event_type.includes('voltage') && `${event.value}V` || `${event.value}A` : 'N/A';
        }else if (event_consumption_anomalies_types.includes(event.event_type)) {
          event.expected_consumption = +this.incidents_data.maxA.toFixed(2) + 'A';
          event.actual_consumption = event.value + 'A';
          let percent = 0;
          if (typeof this.incidents_data.maxA === 'number' && this.incidents_data.maxA !== 0) {
            percent = (parseInt(event.value, 10) / this.incidents_data.maxA - 1) * 100;
          }
          event.percentage_deviation = percent.toFixed(2) + '%';
        }else {
          event.actual_consumption = event.value + 'A';
        }

        if (event_types[event.event_type]) {
          event_types[event.event_type].list.push(event);
        }else {
          event_types[event.event_type] = {};
          event_types[event.event_type].list = [event];
        }
      });

      this.event_types = event_types;
    }
}

export default IncidentsTab;
